import { HeaderRightItemMobile } from './HeaderRightItemMobile';
import { HeaderRightItemDesktop } from './HeaderRightItemDesktopV2';

export const HeaderRightItemSlot = {
  desktop: HeaderRightItemDesktop,
  mobile: HeaderRightItemMobile,
};
